import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { MyAddressBookService } from 'src/app/services/feature/kb-My-Address-Book/kb-my-address-book.service';

@Component({
  selector: 'app-delete-popup2',
  templateUrl: './delete-popup2.component.html',
  styleUrls: ['./delete-popup2.component.scss'],
  standalone: false
})
export class DeletePopup2Component {
  isMobile: boolean = false;
  sub = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any,
    private service: MyAddressBookService,
    public breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<DeletePopup2Component>,
    private globalMsg: GlobalMessageService
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe(result => {
          this.isMobile = result.matches;
        }));
  }

  deleteAddress(id) {
    this.sub.add(this.service.removeAddress(id).subscribe((response: any) => {

      this.dialogRef.close(response);
    }));
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
